import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Field } from "@/components/intake/StepContact";

export function BigSelect({ value, onChange, options, placeholder, testId }) {
  return (
    <Select value={value || ""} onValueChange={onChange}>
      <SelectTrigger className="field-input h-auto text-left [&>span]:line-clamp-2" data-testid={testId}>
        <SelectValue placeholder={placeholder} />
      </SelectTrigger>
      <SelectContent className="border-2 border-black">
        {options.map((o) => (
          <SelectItem key={o} value={o} className="py-2.5 text-base" data-testid={`${testId}-option`}>
            {o}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}

export function StepProduct({ form, update, errors, config }) {
  return (
    <div className="space-y-6">
      <h2 className="font-display text-2xl font-bold">Step 2 · What is your query about?</h2>
      <Field label="Choose a product or topic" error={errors.product} testId="field-product">
        <BigSelect
          value={form.product}
          onChange={(v) => update({ product: v, query: "", addons: [], batch_mode: "", batch: "" })}
          options={config.products}
          placeholder="Select one…"
          testId="product-select"
        />
      </Field>
    </div>
  );
}
